module.exports = __webpack_public_path__ + "static/318243694_666024418527330_3637593781471252150_n.jpg-1671186393155_512-bc5ff71861bd7e7c695eb3c4336dffd9.webp";